import { render, staticRenderFns } from "./eventPollings.vue?vue&type=template&id=1cc06c6e&scoped=true"
import script from "./eventPollings.vue?vue&type=script&lang=js"
export * from "./eventPollings.vue?vue&type=script&lang=js"
import style0 from "./eventPollings.vue?vue&type=style&index=0&id=1cc06c6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc06c6e",
  null
  
)

export default component.exports